// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3d-1";
export var movingGradient = "_3d-4";
export var movingGradientBlock = "_3d-2";
export var skeleton = "_3d-0";
export var skeletonText = "_3d-3";